import { createActions, createReducer } from 'reduxsauce'

import DetalhesAdiantamentosSuprimentosService from '../../servicos/DetalhesAdiantamentosSuprimentosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesAdiantamentosSuprimentosInicio: [],
    buscaDetalhesAdiantamentosSuprimentosSucesso: ['detalhesAdiantamentosSuprimentos'],
    buscaDetalhesAdiantamentosSuprimentosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesAdiantamentosSuprimentos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesAdiantamentosSuprimentosInicio())
        let serv = new DetalhesAdiantamentosSuprimentosService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesAdiantamentosSuprimentosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesAdiantamentosSuprimentosErro(error)))
    }
}

const buscaDetalhesAdiantamentosSuprimentosInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesAdiantamentosSuprimentosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesAdiantamentosSuprimentosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesAdiantamentosSuprimentos, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_ADIANTAMENTOS_SUPRIMENTOS_INICIO]: buscaDetalhesAdiantamentosSuprimentosInicio,
    [Types.BUSCA_DETALHES_ADIANTAMENTOS_SUPRIMENTOS_ERRO]: buscaDetalhesAdiantamentosSuprimentosErro,
    [Types.BUSCA_DETALHES_ADIANTAMENTOS_SUPRIMENTOS_SUCESSO]: buscaDetalhesAdiantamentosSuprimentosSucesso,
})
